import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
	comments: [],
});

const actions = {
	fetchAll({commit}, {restaurantId, branchId, foodId}) {
		return axios.get(`/api/restaurants/${restaurantId}/branches/${branchId}/food/${foodId}/comments`).then(response => {
			commit(types.STORE_COMMENTS, response.data);

			return response.data;
		});
	},

	delete({commit}, {restaurantId, branchId, foodId, commentId}) {
		return axios.delete(`/api/restaurants/${restaurantId}/branches/${branchId}/food/${foodId}/comments/${commentId}`).then(response => {
			commit(types.DELETE_ONE_COMMENT, commentId);
		});
	}
};

const mutations = {
	[types.STORE_COMMENTS](state, comments) {
		state.comments = unionState(state.comments, comments);
	},

	[types.DELETE_ONE_COMMENT](state, id) {
		state.comments = state.comments.filter(n => n.id !== id);
	},
};

const getters = {
	getById: state => id => state.comments.find(n => n.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};